@let created = createdAt();
@let updated = updatedAt();
@let currentDraft = draft();
@let withBadges = showBadges();

<div class="px-[1.25rem] pt-[1rem] pb-[0.75rem]"
     [class]="tabs.isEditing() ? 'border-b border-b-(--p-blue-50)' : ''">
  <div class="flex items-center justify-between gap-[1rem]"
       [class]="withBadges ? 'max-sm:flex-wrap max-sm:gap-y-[0.5rem]' : ''">
    <div class="flex min-w-0 flex-1 items-center gap-[0.75rem]"
         [class]="withBadges ? 'max-sm:order-3 max-sm:w-full max-sm:flex-none' : ''">
      <h2 class="min-w-0 text-[0.875rem] font-semibold leading-[150%] text-(--p-gray-950) truncate">{{ title() | async }}</h2>

      @if (dialogState.isHidden()) {
        <span class="flex shrink-0 items-center gap-[0.25rem] text-(--p-gray-500)">
          <svg-icon src="icons/icon-eye-hide.svg" name="icon-eye-hide" class="size-[1.25rem] shrink-0"></svg-icon>
          <span class="whitespace-nowrap text-[0.75rem] font-medium leading-[150%]"
                translate="@@shared-events-visibility__hidden"></span>
        </span>
      }
    </div>

    <div class="flex items-start gap-[0.5rem] shrink-0 max-sm:contents">
      @if (withBadges) {
        <gc-dialog-event-badges class="max-sm:order-2 max-sm:w-full"
                                [status]="currentDraft.status"
                                [investigationResult]="currentDraft.investigationResult"
                                [repairStatus]="dialogState.repairStatus()"
                                [hiddenEvent]="dialogState.isHidden()"></gc-dialog-event-badges>
      }
      
      <div class="flex items-center gap-1 pt-[0.25rem] max-sm:order-1"
           [class]="withBadges ? 'max-sm:w-full max-sm:justify-end' : ''">
        <p-button icon="true"
                  severity="contrast"
                  rounded="true"
                  styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
                  [text]="true"
                  (click)="closeRequested.emit()"
                  [pTooltip]="'@@shared-close' | translate"
                  tooltipPosition="bottom"
                  tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
          <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
        </p-button>
      </div>
    </div>
  </div>

  @if (created || updated) {
    <div class="mt-[0.5rem] flex flex-wrap items-center gap-[0.75rem] font-medium text-[0.6875rem] leading-[150%] text-(--p-gray-500) max-sm:flex-col max-sm:items-start max-sm:gap-[0.25rem]">
      @if (created) {
        <span>
          <span [translate]="isAutoCreated() ? '@@fp-event-header__auto-created' : '@@fp-event-header__manually-created'"></span>
          <span class="ml-[0.25rem] font-medium text-(--p-gray-950)">{{ created | dayjs: dateFormat }}</span>
        </span>
      }

      @if (created && updated) {
        <span class="h-[0.875rem] w-[1px] bg-(--p-primary-100) shrink-0 max-sm:hidden"></span>
      }

      @if (updated) {
        <span>
          <span translate="@@fp-event-header__updated"></span>
          <span class="ml-[0.25rem] font-medium text-(--p-gray-950)">{{ updated | dayjs: dateFormat }}</span>
        </span>
      }
    </div>
  }
</div>
